import React, { Component } from "react"
import {InlineWidget} from 'react-calendly'
import Layout from "../../components/layout"
import Seo from "../../components/SEO/seo"
import { CenterTitle } from "../../components/titles/titles"

class Calendly extends Component {
  componentDidMount() {
    // whatever stuff you need here
  }
  componentWillUnmount() {
    // whatever cleanup stuff you need here
  }
  render(){
    return (
      <Layout location="Booking" title="Onai">
        <Seo title="15 Minutes Booking" />
        <div className="container py-5">
          <CenterTitle subcolor="Remote " title=" Consultation"  subtitle="Simple call or share your screen for quick prognosis"/>
          <div className="col-md">
            <h5 className="text-center">Need a walkthrough on your computer?
            </h5>
            <p className="text-center lead">Share your screen and take us through the problem you are having.
              We can give you an idea of what you need to do to solve the issue. Pick a date and time slot and
            we will book you in!</p>
          </div>
          <InlineWidget url="https://calendly.com/onai/15min" />
        </div>

      </Layout>
    );
  }
}

export default Calendly